import React from 'react';
import './FooterInfo.css';

export function FooterInfo() {
  return (
    <div className="footer-info">
      <p className="footer-info__partner">
        AIMUS ARCHERY PLATFORM | Data-Driven Archery Training Solution
      </p>
      <p className="footer-info__desc">
        에이머스(AIMERS)는 대한민국 양궁 선수와 동호인을 위한 데이터 분석 및 정밀 기록 플랫폼입니다.
      </p>
      <p className="footer-info__contact">
        Contact : <a href="mailto:aimus1440@gmail.com">aimus1440@gmail.com</a>
      </p>
    </div>
  );
}
